module.exports = __webpack_public_path__ + "static/public_wifi-489ffb27cf6b1f8ba0facac037365be7.png";